export default __webpack_public_path__ + "static/media/toggle.b02b0efc.svg";